import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaFileAlt } from "react-icons/fa";

const KINDS = {
  any: "Any attachment",
  pdf: "PDF / documents",
  audio: "Audio & voice notes",
  image: "Images",
};

export default function AIAnalyzerNode({ data, selected }) {
  const kinds = Array.isArray(data.analysisKinds) && data.analysisKinds.length > 0
    ? data.analysisKinds
    : ["any"];
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[190px] transition-shadow ${
        selected ? "border-sky-500 shadow-md" : "border-surface-border"
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-sky-500 !border-2 !border-white"
      />

      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-gradient-to-r from-sky-600 to-cyan-500">
        <FaFileAlt size={11} className="text-white" />
        <span className="text-xs font-semibold text-white">AI Analyzer</span>
      </div>

      <div className="px-3 py-2.5 space-y-1.5">
        {data.instruction ? (
          <p className="text-xs text-ink-muted line-clamp-2">{data.instruction}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to configure analysis</p>
        )}
        <div className="flex items-center gap-1.5 flex-wrap">
          {kinds.map((k) => (
            <span key={k} className="inline-flex items-center px-1.5 py-0.5 rounded bg-sky-100 text-sky-700 text-2xs font-medium">
              {KINDS[k] || k}
            </span>
          ))}
          {data.respondInChat !== false ? (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-indigo-100 text-indigo-700 text-2xs font-medium">
              Replies in chat
            </span>
          ) : (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-slate-100 text-slate-700 text-2xs font-medium">
              Silent output
            </span>
          )}
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-sky-500 !border-2 !border-white"
      />
    </div>
  );
}
